/**
 * @file: 画布矩阵变换
 * @author: xiaolong.huang@dmall.com
 */

import Visit from '../visit';
import { init } from './init';
import { getInstance } from './get';
import { updateTransformConfig } from './updateConfig';
import { zoomIn, zoomOut, zoomTo } from './zoom';
import { moveTo } from './move';
import { fullscreenScale } from './fullscreenScale';
import { resizeToStage } from './resizeToStage';

// 解决循环引用，往公共对象上挂
function mountApi() {
    Visit.Transform = {
        zoomIn,
        zoomOut,
        zoomTo,
        moveTo,
        getInstance,
        updateTransformConfig,
        fullscreenScale,
        resizeToStage
    };
}

export default {
    init,
    mountApi,
    zoomIn,
    zoomOut,
    zoomTo,
    moveTo,
    getInstance,
    updateTransformConfig,
    fullscreenScale,
    resizeToStage
}
